// extracted by mini-css-extract-plugin
export default {"written":"list_written__RcBWc"};